import Layout from '@/components/Layout/Vanilla';
import CardGrid from '@/components/CardGrid';
import EmptyState from '@/components/EmptyState';
import EventCard from '@/components/EventCard';
import Hero from '@/components/Hero';
import Section from '@/components/Section';
import SectionHero from '@/components/SectionHero';
import { fetchPage, gql } from '@/lib/graphcms';

export default function Events({ page, events }) {
  const [upcomingEvents, pastEvents] = events.reduce(
    ([u, p], e) =>
      new Date(e.starts) > new Date() ? [[...u, e], p] : [u, [...p, e]],
    [[], []],
  );

  return (
    <Layout seo={page}>
      <Section>
        <Hero {...page} />
      </Section>
      <Section colour="light">
        <SectionHero title="Upcoming Events" />
        {!upcomingEvents.length ? (
          <EmptyState message="No upcoming events" />
        ) : (
          <CardGrid entries={upcomingEvents} Component={EventCard} {...page} />
        )}
      </Section>
      <Section>
        <SectionHero title="Past Events" />
        {!pastEvents.length ? (
          <EmptyState message="No past events" />
        ) : (
          <CardGrid
            entries={pastEvents}
            Component={EventCard}
            truncatedText
            {...page}
          />
        )}
      </Section>
    </Layout>
  );
}

export const getStaticProps = async ({ preview = false }) => {
  const { events, page } =
    (await fetchPage(
      gql`
        fragment resourceData on Resource {
          id
          slug
          title
          subTitle
          coverImage {
            ...assetDataSM
          }
          speakers {
            ...authorData
          }
          content
          externalUrl
          location
          starts
          ends
          type
          file {
            ...assetDataXL
          }
          preWebinarSuccessContent
          resourceUrl
          successContent
          meta: seo {
            ...seoData
          }
          mqlInterest
          hubSpotFormId
          formTitle
        }

        query eventsPageQuery {
          events: resources(
            orderBy: starts_DESC
            where: { type_in: [CONFERENCE, MEETUP, WORKSHOP] }
          ) {
            ...resourceData
          }
          page(where: { slug: "events" }) {
            ...pageData # Fragment is inside the method
          }
        }
      `,
      {
        preview,
      },
    )) || [];

  return {
    props: {
      preview,
      events,
      page,
    },
    revalidate: 3600,
  };
};
